import {Route} from 'react-router'
import {BillingInfos, ShowBillingInfo, PriceAgreement, EditBillingInfo} from './billing_infos'
import {EditInvoice, PerformInvoicing, UnpaidInvoices} from './unpaid_invoices'
import {ProtectedRoute, RecordsRoute} from '~/routing/components'

export const routes = (
	<Route path="/billing">
		<Route element={<RecordsRoute awaitRecords={['billingInfos', 'environments', 'organisations']} />}>
			<Route path="billing_infos" element={<BillingInfos />} />
			<Route path="billing_infos/:id" element={<ShowBillingInfo />} />
			<Route path="billing_infos/:id/price_agreement" element={<PriceAgreement />} />
			<Route path="billing_infos/:id/edit" element={<EditBillingInfo />} />
		</Route>
		<Route element={<RecordsRoute awaitRecords={['environments', 'organisations']} />}>
			<Route path="unpaid_invoices" element={<UnpaidInvoices />} />
			<Route path="unpaid_invoices/:id/edit" element={<EditInvoice />} />
		</Route>
		<Route element={<ProtectedRoute enableRole="admin" />}>
			<Route path="perform_invoicing" element={<PerformInvoicing />} />
		</Route>
	</Route>
)
